import { Entity, IEntity } from "./Entity";
import { IUser } from "./User";
import { IApp03Portfolio } from "./App03Portfolio";
import { IApp03Epic } from "./App03Epic";

export interface IApp03EpicObserver extends IEntity {
    UserID?: number;
    EpicID?: number;
    User?: IUser;
    Epic?: IApp03Epic;
}

export class App03EpicObserver extends Entity implements IApp03EpicObserver {
    public UserID = null;
    public EpicID = null;

    constructor() {
        super();
    }
}